__turbopack_context__.v({
  "className": "inter_8007f9ea-module__JkbZVW__className",
  "variable": "inter_8007f9ea-module__JkbZVW__variable",
});
